/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { UserSettingsPutNotifications } from './userSettingsPutNotifications';

export interface UserSettingsPut {
  capture_enabled?: boolean | null;
  calendar_join_enabled?: boolean | null;
  video_enabled?: boolean | null;
  notifications?: UserSettingsPutNotifications;
}
